module.exports = __webpack_public_path__ + "img/product-2.776e31b4.jpg";